import { Filters } from '@apps/accommodations/AccommodationsConsole.types';
import { ACCOMMODATIONS_DEFAULT_LOCATION } from '@shared/constants/accommodations';

/**
 * root query param in which all accommodations console query params are nested under
 */
export const ACCOMMODATIONS_CONSOLE_ROOT_QUERY_PARAM_KEY = 'acs';

export const PRICE_RANGE = {
  MIN: 0,
  MAX: 1000,
} as const;

export const DEFAULT_OCCUPANCY = {
  unitCount: 1,
  occupancies: [
    {
      adults: 2,
      childrenAges: [],
    },
  ],
};

export const DEFAULT_SEARCH_RADIUS = 4; // Default search radius in km

export const DEFAULT_LOCATION = {
  destination: ACCOMMODATIONS_DEFAULT_LOCATION.name,
  lat: ACCOMMODATIONS_DEFAULT_LOCATION.lat,
  lng: ACCOMMODATIONS_DEFAULT_LOCATION.long,
  googlePlaceId: ACCOMMODATIONS_DEFAULT_LOCATION.placeId,
} as const;

export const QUERY_PARAM_KEYS = {
  checkin: 'checkin',
  checkout: 'checkout',
  destination: 'destination',
  lat: 'lat',
  lng: 'lng',
  radius: 'radius',
  rooms: 'rooms',
  googlePlaceId: 'googlePlaceId',
};

export const FILTER_QUERY_PARAM_KEYS = {
  FACILITIES: 'facilities',
  STAR_RATING: 'starRating',
  USER_RATING: 'userRating',
  PRICE_MIN: 'priceMin',
  PRICE_MAX: 'priceMax',
  CUG: 'cug',
  PICKED_BY_COUPLE: 'pickedByCouple',
  SHOW_AVAILABLE_ONLY: 'showAvailableOnly',
};

export const DEFAULT_FILTERS: Filters = {
  facilities: [],
  starRating: [],
  userRating: [],
  priceRange: [PRICE_RANGE.MIN, PRICE_RANGE.MAX],
  cug: false,
  pickedByCouple: false,
  showAvailableOnly: true,
};

export const SORT_QUERY_PARAM_KEY = 'sort';
